import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { individualCalculatedPoints, individualPoints } from '../api';
import Points from '../components/Points';
import { AuthContext } from '../context/AuthContext';
import {
  ICalculatedIndividualPoints,
  IIndividualPointResult,
} from '../utils/types';

export function PointsContainer() {
  const { t } = useTranslation();
  const { token } = useContext(AuthContext);
  const [points, setPoints] = useState<IIndividualPointResult[]>();
  const [calculatedPoints, setCalculatedPoints] =
    useState<ICalculatedIndividualPoints>();

  useEffect(() => {
    fetchUserPoints();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserPoints = async () => {
    const calcPoints = await individualCalculatedPoints(token);
    setCalculatedPoints(calcPoints);

    const res = await individualPoints(token);
    setPoints(res);
  };

  if (!points) return <Box sx={{ mt: 1 }}>{t('pointsContainer.loading')}</Box>;

  return <Points points={points} calculatedPoints={calculatedPoints} />;
}
